export class FastPreviewError extends Error {
  constructor(message: string) {
    super(`Fast Preview: ${message}`)
    this.name = 'FastPreviewError'
    Object.setPrototypeOf(this, FastPreviewError.prototype)
  }
}
